
import { Component, Vue } from 'vue-property-decorator'
import BackNav from '@/components/BackNav/index.vue'
import { joinStore } from '@/api/store'
import { Getter } from 'vuex-class'
import { encryptData } from '@/utils/encryptData'

@Component({
  name: 'JoinStore',
  components: {
    BackNav
  }
})
export default class JoinStore extends Vue {
  @Getter mobile!: string
  // 账号标识
  accountId = ''

  // 临时密码
  tempPassword = ''

  // 是否显示密码错误提示
  showPasswordError = false

  // 错误提示
  errorMsg = ''
  showErrorMsg = false
  isShake = false
  errShakeClass = 'animate__animated animate__headShake'


  // 账号标识输入
  onAccountIdInput() {
    this.isShake = false
    this.showErrorMsg = false
    this.errorMsg = ''
    this.showPasswordError = false
  }

  // 密码输入
  onPasswordInput() {
    this.isShake = false
    this.showErrorMsg = false
    this.errorMsg = ''
    this.showPasswordError = false
  }

  // 加入店铺
  async onJoin() {
    if (this.showErrorMsg) {
      this.isShake = true
      setTimeout(() => {
        this.isShake = false
      }, 1000)
      return
    }

    // 验证账号标识格式
    if (!this.validateAccountId()) {
      this.$toast('账号标识格式不正确，格式为xx@xx')
      return
    }

    if (this.tempPassword.trim() === '') {
      this.$toast('临时密码不能为空')
      return
    }

    try {
      const res = await joinStore({
        registMobile: this.mobile,
        account: encryptData(this.accountId),
        password: encryptData(this.tempPassword)
      })
      if (res.code === '000000') {
        this.$toast.clear()
        this.$toast.success('加入成功')
        this.$router.back()
      } else {
        this.$toast.clear()
        this.showPasswordError = true
        this.$toast.fail(res.msg || '加入店铺失败');
      }
    } catch (error) {
      this.$toast.clear()
      if (error.data.msg === "账号不存在") {
        this.errorMsg = error.data.msg
        this.showErrorMsg = true
      } else if (error.data.msg === "密码错误") {
        this.errorMsg = error.data.msg
        this.showErrorMsg = true
        this.showPasswordError = true
      }
      this.$toast.fail(error.data.msg || '加入店铺失败')
    }
  }

  // 验证账号标识格式
  validateAccountId() {
    // 格式为 xx@xx
    const regex = /^.+@.+$/
    return regex.test(this.accountId)
  }
}
